"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setSelectedBlockFromTutorialForRight = exports.setSelectedBlockFromTutorialForLeft = exports.selectedBlockFromTutorialForRight = exports.selectedBlockFromTutorialForLeft = void 0;
let selectedBlockFromTutorialForLeft = exports.selectedBlockFromTutorialForLeft = undefined;
let selectedBlockFromTutorialForRight = exports.selectedBlockFromTutorialForRight = undefined;
const setSelectedBlockFromTutorialForLeft = block => {
  if (!block) return;
  exports.selectedBlockFromTutorialForLeft = selectedBlockFromTutorialForLeft = block;
};
exports.setSelectedBlockFromTutorialForLeft = setSelectedBlockFromTutorialForLeft;
const setSelectedBlockFromTutorialForRight = block => {
  if (!block) return;
  exports.selectedBlockFromTutorialForRight = selectedBlockFromTutorialForRight = block;
};
exports.setSelectedBlockFromTutorialForRight = setSelectedBlockFromTutorialForRight;